import ReactDOM from "react-dom";
import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { communityBtnStyle } from "../styles/styles";
import { useTranslation } from "react-i18next";

function ViewCommunityManagerButton(props) {
  const { handleCommunityManagerClick } = props;
  const [container, setContainer] = useState(null);

  const { t } = useTranslation('pricelist-header-content');

  useEffect(() => {
    const target = document.getElementById("header-button-box");
    setContainer(target);
  }, []);

  if (!container) return null;

  return ReactDOM.createPortal(
    <Box onClick={handleCommunityManagerClick} sx={communityBtnStyle}>
      <img src="/glass_icon.svg" alt="glass_icon" width={24} />

      <Typography
        sx={{
          color: "#2F2B3D",
          fontSize: "15px",
          fontWeight: 500,
          lineHeight: "100%",
        }}
      >
        {t('view_as_community_manager')}
      </Typography>
    </Box>,
    container
  );
}

export default ViewCommunityManagerButton;
